import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';
import { withGlow } from '../../helpers/with-glow';

export function buildStage11(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  tl.to(
    refs.blobs.pink.current,
    {
      y: vh(-0.13),
      x: vw(0.22),
      duration: 1,
    },
    'stage11'
  )
    .to(refs.prayer.container.current, { y: vh(0.23), duration: 1 }, 'stage11')
    .to(refs.prayer.title.current, { alpha: 0, duration: 1 }, 'stage11')
    .to(refs.prayer.content.current, { alpha: 0, duration: 1 }, 'stage11')
    .to(refs.prayer.info.current, { alpha: 0, duration: 1 }, 'stage11')
    .to(refs.mainPrayer.container.current, { y: vh(0.23), alpha: 1, duration: 1 }, 'stage11')
    .to(
      refs.glowCircle.current,
      {
        alpha: 1,
        duration: 1,
      },
      'stage11'
    )
    .to(
      refs.buttons.action.current,
      {
        y: vh(-0.45),
        duration: 1,
      },
      'stage11'
    )
    .to(
      refs.buttons.decor.current,
      {
        y: vh(-0.45),
        duration: 1,
      },
      'stage11'
    )
    .to(
      refs.stars[6].current,
      {
        x: vw(-0.37),
        y: vh(0.016),
        scale: 1.35,
        duration: 0.01,
        ...withGlow(refs.stars[6].current),
      },
      'stage11'
    )
    .to(
      refs.stars[6].current,
      {
        alpha: 1,
        duration: 1,
      },
      'stage11'
    );

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage11',
    animations: [
      {
        x: vw(0.455),
        y: vh(-0.155),
        duration: 1,
      },
      {
        x: vw(0.33),
        y: vh(-0.334),
        duration: 1,
      },
      {
        x: vw(0.221),
        y: vh(0.043),
        duration: 1,
      },
      {
        x: vw(-0.224),
        y: vh(-0.363),
        duration: 1,
      },
      {
        x: vw(-0.455),
        y: vh(-0.272),
        duration: 1,
      },
      {
        x: vw(0),
        y: vh(-0.55),
        scale: 10,
        alpha: 0,
        boxShadow: '0px 0px 62px 11px #f5e7ba',
        duration: 1,
      },
    ],
  });
}
